import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CHECKOUT_FEATURE } from '@spartacus/checkout/base/root';
import { effectsCheckout } from './effects/index';
import { reducerProvider, reducerToken } from './reducers/index';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(CHECKOUT_FEATURE, reducerToken),
    EffectsModule.forFeature(effectsCheckout),
  ],
  providers: [reducerProvider],
})
export class CustomCheckoutStoreModule { }
